/**
 * Amount entity class
 */

/**
 * AmountFactory
 * returns Amount entity class
 *
 * @class AmountFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Amount} class
 *
 * @ngdoc factory
 * @name mwApp.factory:AmountFactory
 */
/* @ngInject */
export default function AmountFactory (Entity, Type) {
  /* === Amount class === */

  /**
   * Amount model
   *
   * @class Amount
   * @classdesc Amount model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing Amount entity fields
   * @return {models.Amount} Amount entity
   */
  function Amount () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  Amount.prototype = Object.create(Entity.prototype)
  Amount.prototype.constructor = Amount

  /* === Amount instance methods & fields === */

  Object.assign(Amount.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Amount#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      amount: 0,
      amountType: Type(String('PRICE')), // AMOUNT_TYPES
      excludeTax: false,
      sortOrder: 0,
      subscription: 'Subscription'
    },

    /**
     * url template
     *
     * @memberof models.Amount#
     * @type {String}
     */
    _urlTemplate: 'api/subscriptions/{{::id}}'

  })

  /* === Amount static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(Amount, Entity)
  Amount._name = 'Amount'
  Amount.init()

  return Amount
}
